import React from "react";
import { Navigate } from "react-router-dom";

import { DemoProvider } from "@/features/demo/components/DemoProvider";
import KitchenPageV3 from "@/features/restaurant/pages/KitchenPage.V3";
import { ProtectedRouteV2 } from "@/components/ProtectedRouteV2";
import { useSmartRouteResolution } from "./smart-routes/useSmartRouteResolution";

const LEGACY_REDIRECTS: Record<string, string> = {
  "/payments": "payments",
  "/qr-codes": "qr-codes",
  "/settings/staff": "settings/staff",
};

const smartRouteDebugEnabled = import.meta.env.DEV && import.meta.env.VITE_DASHBOARD_DEBUG === "1";

export const SmartKitchenRoute: React.FC = () => {
  const resolution = useSmartRouteResolution({
    routeKey: "kitchen",
    legacyRedirects: LEGACY_REDIRECTS,
  });

  if (smartRouteDebugEnabled) {
    console.debug("[SmartKitchenRoute] context:", resolution.context);
  }

  if (resolution.redirectPath) {
    return <Navigate to={resolution.redirectPath} replace />;
  }

  if (resolution.shouldRenderDemo) {
    return (
      <DemoProvider>
        <KitchenPageV3 />
      </DemoProvider>
    );
  }

  return (
    <ProtectedRouteV2 legacyPage="kitchen">
      <KitchenPageV3 />
    </ProtectedRouteV2>
  );
};
